export default __webpack_public_path__ + "static/media/poloniex.c659ec7a.png";